import React from 'react';
import PropTypes from 'prop-types';
import SlideShow from '../SlideShow/SlideShow';
import _ from 'lodash';
import './Card.css';

const Card = props => {
  const price = _.get(props, 'item.data.price', 0);
  return (
    <div className="card" style={{ width: `${props.width}px`, height: `${props.height}px` }}>
      <div className="card-img-holder">
        {price > 0 && <span className="proMark"></span>}
        {props.customImage ? (
          props.customImage(props.item)
        ) : props.srcSet ? (
          <SlideShow srcSet={props.srcSet} />
        ) : (
          <img src={props.src} loading="lazy" alt={_.get(props, 'item.data.name', '')} />
        )}
      </div>
      <footer></footer>
    </div>
  );
};

Card.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  customImage: PropTypes.func,
  item: PropTypes.any,
  src: PropTypes.string,
  srcSet: PropTypes.arrayOf(PropTypes.string),
  price: PropTypes.number,
};

export default Card;
